module.exports = __webpack_public_path__ + "img/1338637425.e05e8b44.jpg";